export default __webpack_public_path__ + "static/media/ic_wave_hand.c3082d35.png";